module.exports = __webpack_public_path__ + "img/default-male.ee144d25.png";